import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'
import styles from './QISoftware.module.scss';

const SASQIDesc = () => {
    return (<>

        <Container className="outerContainer">
            <h3 className="mb-4 centerText">SAS QI v2021 Individual Software Downloads</h3>
            <Row>
                <Col xs={12} md={3} className='stretchCard'>
                    <Card className="mb-4 centerText fullwidth">
                        <Card.Body>
                            <Card.Title>Prevention Quality Indicators (PQI)</Card.Title>
                            <Card.Text>
                                Version v2021 (July 2021)</Card.Text>
                            <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/PQI_SAS_V2021_QI_SOFTWARE.zip" variant="primary">Download</Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12}  md={3}  className='stretchCard'>
                    <Card className="mb-4 centerText fullwidth">
                        <Card.Body>
                            <Card.Title>Inpatient Quality Indicators (IQI)</Card.Title>
                            <Card.Text>
                                Version v2021 (July 2021)

                            </Card.Text>
                            <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/IQI_SAS_V2021_QI_SOFTWARE.zip" variant="primary">Download</Button>
                            <br />
                            <p className="subtitle mt-2"><a href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/APRDRG_LIMITED_GROUPER_2021.zip">3M Limited License APR-DRG Grouper Download 2021</a></p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12}  md={3}  className='stretchCard'>
                    <Card className="mb-4 centerText fullwidth">
                        <Card.Body>
                            <Card.Title>Patient Safety Indicators (PSI)</Card.Title>
                            <Card.Text>
                                Version v2021 (July 2021)</Card.Text>
                            <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/PSI_SAS_V2021_QI_SOFTWARE.zip" variant="primary">Download</Button>
                            <br />
                            <p className="subtitle mt-2"><a href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/PSI17_SAS_V2021_QI_SOFTWARE.zip">PSI #17 Download</a></p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12}  md={3}  className='stretchCard'>
                    <Card className="mb-4 centerText fullwidth">
                        <Card.Body>
                            <Card.Title>Pediatric Quality Indicators (PDI)</Card.Title>
                            <Card.Text>
                                Version v2021 (July 2021)

                            </Card.Text>
                            <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/SAS/V2021/PDI_SAS_V2021_QI_SOFTWARE.zip" variant="primary">Download</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>)
}

export default SASQIDesc;